<template>
  <label class="input">
    <input
      ref="input"
      type="checkbox"
      class="checkbox"
      :checked="checked"
      @change="$emit('change', $event.target.checked)"
    >
    <span class="input-label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'CheckboxItem',
  props: {
    label: { type: String, required: true },
    checked: Boolean,
    indeterminate: Boolean,
  },
  mounted() {
    this.setIndeterminate()
  },
  updated() {
    this.setIndeterminate()
  },
  methods: {
    setIndeterminate() {
      if (this.$refs.input) {
        this.$refs.input.indeterminate = this.indeterminate
      }
    },
  },
}
</script>

<style scoped>
.input {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 4px;
  cursor: pointer;
}

.checkbox {
  width: 16px;
  height: 16px;
}

.input-label {
  font-size: 14px;
  line-height: 21px;
}
</style>
